module.exports = __webpack_public_path__ + "img/سربرگ.81ccb1c2.png";